export default __webpack_public_path__ + "static/media/ProductFeedExample.1674e624.xlsx";